import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n'], ['\n  display: flex;\n  flex-direction: column;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  &&&&&& {\n    color: ', ';\n  }\n'], ['\n  &&&&&& {\n    color: ', ';\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  position: relative;\n  float: right;\n'], ['\n  position: relative;\n  float: right;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  &&& {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: white;\n    padding: 3px;\n    border-radius: 50%;\n    box-sizing: content-box;\n  }\n'], ['\n  &&& {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    background-color: white;\n    padding: 3px;\n    border-radius: 50%;\n    box-sizing: content-box;\n  }\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n  &&&&& {\n    path {\n      fill: ', ';\n    }\n  }\n'], ['\n  &&&&& {\n    path {\n      fill: ', ';\n    }\n  }\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n  border-radius: 2px 2px 0 0;\n  background-color: #e7f6fd;\n  margin: 0px 36px;\n  padding: 20px;\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  border-bottom-color: ', ';\n'], ['\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n  border-radius: 2px 2px 0 0;\n  background-color: #e7f6fd;\n  margin: 0px 36px;\n  padding: 20px;\n  border-bottom-width: 2px;\n  border-bottom-style: solid;\n  border-bottom-color: ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color: #211551;\n  font-size: ', ';\n'], ['\n  color: #211551;\n  font-size: ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n  color: ', ';\n  font-size: 10px;\n  text-decoration: underline;\n  cursor: pointer;\n  min-width: 15px;\n'], ['\n  color: ', ';\n  font-size: 10px;\n  text-decoration: underline;\n  cursor: pointer;\n  min-width: 15px;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  padding-top: 2px;\n  padding-right: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n'], ['\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 20px;\n  height: 20px;\n  padding-top: 2px;\n  padding-right: 2px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n']);

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, UserPicture, Tooltip } from '../../..';
import AnimateHeight from 'react-animate-height';
import SearchDropdownRow from '../../rows/SearchDropdownRow';
import { styles, utils } from 'gipsy-misc';
import Field, { Close } from '../Field';
import injected from '../../../injected';

var actionColor = '#13A8F4';

var WatcherAndReviewer = function (_PureComponent) {
  _inherits(WatcherAndReviewer, _PureComponent);

  function WatcherAndReviewer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WatcherAndReviewer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WatcherAndReviewer.__proto__ || Object.getPrototypeOf(WatcherAndReviewer)).call.apply(_ref, [this].concat(args))), _this), _this.deactivateField = function (e) {
      var _this$props = _this.props,
          id = _this$props.id,
          value = _this$props.value;


      _this.props.deactivateField && _this.props.deactivateField(e, id);
    }, _this.toggleField = function (e) {
      _this.props.toggleField(e, _this.props.id);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WatcherAndReviewer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          isActive = _props.isActive,
          isOpen = _props.isOpen,
          toggleField = _props.toggleField,
          onSelect = _props.onSelect,
          value = _props.value,
          defaultContacts = _props.defaultContacts,
          title = _props.title,
          icon = _props.icon,
          showStar = _props.showStar,
          defautBehaviorMessage = _props.defautBehaviorMessage,
          defautBehaviorActionMessage = _props.defautBehaviorActionMessage,
          onClickDefaultBehavior = _props.onClickDefaultBehavior,
          showDefaultBehavior = _props.showDefaultBehavior,
          onCloseDefaultBehavior = _props.onCloseDefaultBehavior;


      var to = this.props.to || injected.user && { userId: injected.user.id };

      return React.createElement(
        WatcherAndReviewerContainer,
        null,
        React.createElement(
          Field,
          {
            className: 'watcher-field' + (isActive ? ' active' : '') + (isOpen ? ' open' : ''),
            onClick: utils.DOM.stopPropagation },
          React.createElement(
            'div',
            {
              className: 'click-field row gp-layout gp-row gp-space-between gp-pointer',
              onClick: function onClick(e) {
                return toggleField(e, id);
              } },
            React.createElement(
              'span',
              { className: 'field-label' },
              React.createElement(ImportantIcon, { icon: icon, className: 'label-icon', fill: showDefaultBehavior ? actionColor : '' }),
              React.createElement(
                LabelText,
                { className: 'label-text gp-pointer', showDefaultBehavior: showDefaultBehavior },
                title
              )
            ),
            React.createElement(
              'span',
              { className: 'value' },
              value.map(function (user, index) {
                return React.createElement(
                  StyledUserPicture,
                  {
                    key: utils.user.getKey(user),
                    border: '3px solid white',
                    size: 36,
                    src: user.picture,
                    style: { right: -18 * index } },
                  React.createElement(Tooltip, { text: utils.user.getDisplayName(user), vs: 42, hs: 18, position: 'top left' }),
                  showStar && index === value.length - 1 && React.createElement(Star, { icon: 'Star', fill: styles.colors.primaryColor, size: 10 })
                );
              })
            )
          ),
          React.createElement(
            AnimateHeight,
            { duration: 300, height: isOpen ? 'auto' : 0 },
            React.createElement(SearchDropdownRow, {
              multipleSelection: true,
              inputIcon: 'User',
              paramName: 'watchers',
              defaultSuggestions: defaultContacts,
              disabledSuggestions: [to],
              value: value,
              onSelect: onSelect,
              onClose: this.toggleField,
              showStar: showStar
            })
          ),
          !value.length ? React.createElement(Close, { onClick: this.deactivateField }) : ''
        ),
        showDefaultBehavior && React.createElement(
          DefautBehaviorPanel,
          null,
          React.createElement(
            PanelTitle,
            null,
            defautBehaviorMessage
          ),
          React.createElement(
            PanelAction,
            { onClick: onClickDefaultBehavior },
            defautBehaviorActionMessage
          ),
          React.createElement(
            CloseIconContainer,
            null,
            React.createElement(Icon, { onClick: onCloseDefaultBehavior, icon: 'Close', fill: actionColor, size: 6 })
          )
        )
      );
    }
  }]);

  return WatcherAndReviewer;
}(PureComponent);

WatcherAndReviewer.propTypes = {
  to: PropTypes.any /* assignee */
  , id: PropTypes.string,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  deactivateField: PropTypes.func,
  toggleField: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  value: PropTypes.array,
  defaultContacts: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  showStar: PropTypes.bool,
  defautBehaviorMessage: PropTypes.string.isRequired,
  defautBehaviorActionMessage: PropTypes.string.isRequired,
  onClickDefaultBehavior: PropTypes.func,
  showDefaultBehavior: PropTypes.bool,
  onCloseDefaultBehavior: PropTypes.func
};
WatcherAndReviewer.defaultProps = {
  value: []
};


export default WatcherAndReviewer;

var WatcherAndReviewerContainer = styled.div(_templateObject);

var LabelText = styled.span(_templateObject2, function (props) {
  return props.showDefaultBehavior ? actionColor : '';
});

var StyledUserPicture = styled(UserPicture)(_templateObject3);

var Star = styled(Icon)(_templateObject4);

var ImportantIcon = styled(Icon)(_templateObject5, function (props) {
  return props.fill;
});

var DefautBehaviorPanel = styled.div(_templateObject6, actionColor);

var PanelTitle = styled.div(_templateObject7, styles.fonts.fontSizeXSmall);
var PanelAction = styled.div(_templateObject8, actionColor);

var CloseIconContainer = styled.div(_templateObject9);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/components/WatcherAndReviewer/index.js
// module id = 502
// module chunks = 0